/**
 * Main → overlay events for meeting-note billing gating, so hitting a limit
 * surfaces as a paywall/upsell instead of a generic failure. Emitted by
 * AudioNoteStateManager (main); handled in the overlay renderer
 * (AssistantEventHandler opens the paywall, the Toaster shows the
 * local-transcription downgrade toast).
 */

/** A meeting start was refused by a billing gate: the server 403 (Recall or
 *  electron session-start routes) or the client-side v2 meeting-hours check.
 *  The recording did not start; there is no local-transcription fallback. */
export const MEETING_LIMIT_REACHED_EVENT = 'meeting:limit-reached'

/** The two 403 reasons from `assertCanStartMeeting`
 *  (apps/http-gateway/src/lib/meeting-start-gate.ts). The gateway fails open
 *  on a billing outage, so `entitlement` against a client that holds a paid
 *  tier means the two disagree about the plan, not that hours ran out. */
export type MeetingGateReason = 'entitlement' | 'hours'

export interface MeetingLimitReachedPayload {
  reason: MeetingGateReason
}

/** A recording is proceeding with local (native) transcription instead of the
 *  cloud pipeline. Outages only: a billing-gated start is refused
 *  (MEETING_LIMIT_REACHED_EVENT) rather than downgraded. */
export const MEETING_TRANSCRIPTION_DOWNGRADED_EVENT = 'meeting:transcription-downgraded'

export interface MeetingTranscriptionDowngradedPayload {
  reason: 'cloud-session-unavailable' // the audio-session POST failed on an outage (non-403)
}
